import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from '@repo/ui/components/empty';

export function ErrorComponent() {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyTitle>Error</EmptyTitle>
        <EmptyDescription>There was an error loading.</EmptyDescription>
        {/*<div className="flex gap-2">*/}
        {/*  <Button onClick={handleReload}>Reload</Button>*/}
        {/*</div>*/}
      </EmptyHeader>
    </Empty>
  );
}
